/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const catalogsSlice = createSlice({
  name: 'catalogs',
  initialState: {
    activities: [],
    preferredBeneficiary: {},
    brands: [],
    colonies: [],
    genders: [],
    maritalStatuses: [],
    models: [],
    nationalities: [],
    occupations: [],
    subbrands: [],
    taxRegimes: {
      physical: [],
      moral: [],
    },
    personType: [],
    usesOfTheVehicle: [],
    vehiclesTypes: [],
    vehicleServices: [],
    versions: [],
  },
  reducers: {
    clearForTypeSelection(state) {
      state.brands = [];
      state.subbrands = [];
      state.models = [];
      state.versions = [];
    },
    clearForBrandSelection(state) {
      state.subbrands = [];
      state.models = [];
      state.versions = [];
    },
    clearForSubbrandSelection(state) {
      state.models = [];
      state.versions = [];
    },
    clearForModelSelection(state) {
      state.versions = [];
    },
    setBrands(state, { payload }) {
      state.brands = payload.brands;
    },
    setSubbrands(state, { payload }) {
      state.subbrands = payload.subbrands;
    },
    setModels(state, { payload }) {
      state.models = payload.models;
    },
    setVersions(state, { payload }) {
      state.versions = payload.versions;
    },
    setActivities(state, { payload }) {
      state.activities = payload.activities;
    },
    setNationalities(state, { payload }) {
      state.nationalities = payload.nationalities;
    },
    setColonies(state, { payload }) {
      state.colonies = payload.colonies;
    },
    setGenders(state, { payload }) {
      state.genders = payload.genders;
    },
    setMaritalStatuses(state, { payload }) {
      state.maritalStatuses = payload.maritalStatuses;
    },
    setOccupations(state, { payload }) {
      state.occupations = payload.occupations;
    },
    setTaxRegimes(state, { payload }) {
      state.taxRegimes.moral = payload.taxRegimes.moral;
      state.taxRegimes.physical = payload.taxRegimes.fisica;
    },
    setPersonType(state, { payload }) {
      state.personType = payload.personType;
    },
    setUsesOfTheVehicle(state, { payload }) {
      state.usesOfTheVehicle = payload.usesOfTheVehicle;
    },
    setVehiclesTypes(state, { payload }) {
      state.vehiclesTypes = payload.vehiclesTypes;
    },
    setVehicleServices(state, { payload }) {
      state.vehicleServices = payload.vehicleServices;
    },
    setBeneficiaries(state, { payload }) {
      state.preferredBeneficiary = payload.preferredBeneficiary;
    },
  },
});

export const catalogsActions = catalogsSlice.actions;

export default catalogsSlice;
/* eslint-enable no-param-reassign */
